export enum TypeAlertEnum {
    success = 'success',
    error = 'error',
    info = 'info',
    warning = 'warning',
}